import React from "react";
import Routes from "./Routes";
import "antd/dist/antd.css";
import "./App.css";
import { theme } from "config/theme";
import styled from "styled-components";
import { ThemeProvider } from "styled-components";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <div id="myapp" style={{ height: "100%", overflow: "auto" }}>
                <Wrapper>
                    <Routes />
                </Wrapper>
            </div>
        </ThemeProvider>
    );
}

export default App;

const Wrapper = styled.div`
    height: 100%;
`;
